// extracted by mini-css-extract-plugin
export const menu = "headerMenu-module--menu--2v0dx";
export const menu__list = "headerMenu-module--menu__list--d1TES";
export const menu__listItem = "headerMenu-module--menu__listItem--19Exg";
export const menu__logo = "headerMenu-module--menu__logo--2Cppo";
export const menu__activeItem = "headerMenu-module--menu__activeItem--2mWhj";